export default "__VITE_ASSET__CP4g9wH1__"